import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface HeaderCategoryData {
  categoryId: string;
  subCategoryId?: string;
  categoryName?: string;
  subCategoryName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderCommunicationService {
  private headerUpdateSubject = new Subject<HeaderCategoryData>();
  private loginModalSubject = new Subject<void>();

  // Observable para que el header se suscriba
  headerUpdate$ = this.headerUpdateSubject.asObservable();

  // Observable para abrir el modal de login
  openLoginModal$ = this.loginModalSubject.asObservable();

  constructor() { }

  // Método para que los componentes de detalle notifiquen al header
  setActiveCategory(data: HeaderCategoryData): void {
    this.headerUpdateSubject.next(data);
  }

  // Método para solicitar la apertura del modal de login desde cualquier componente
  requestOpenLoginModal(): void {
    this.loginModalSubject.next();
  }

  // Método para mapear categoryName y subCategoryName a IDs
  getCategoryId(categoryName: string): string {
    const categoryMap: Record<string, string> = {
      'FOTOGRAFIAS': '1',
      'PORTADAS_HISTORICAS': '2',
      'HEMEROTECA': '3'
    };
    return categoryMap[categoryName?.toUpperCase()] || '1';
  }

  getSubCategoryId(subCategoryName: string): string {
    if (!subCategoryName) return '';

    const normalizedName = subCategoryName.toUpperCase().trim();

    const subCategoryMap: Record<string, string> = {
      // Fotografías - usando múltiples variantes
      'CULTURA': '1',
      'CULTURAL': '1',
      'CULTURALES': '1',
      'POLITICA': '2',
      'POLÍTICA': '2',
      'POLITICAS': '2',
      'DEPORTES': '3',
      'DEPORTE': '3',
      'DEPORTIVOS': '3',
      'ESPECTACULOS': '4',
      'ESPECTÁCULOS': '4',
      'ESPECTACULO': '4',
      'REGIONES': '11',
      'REGION': '11',
      'ECONOMIA': '12',
      'ECONOMÍA': '12',
      'ECONOMICAS': '12',
      'SOCIEDAD': '13',
      'SOCIAL': '13',
      'SOCIALES': '13',
      'PRESIDENTES': '14',
      'PRESIDENTE': '14',
      'PRESIDENCIAL': '14',
      // Portadas - todas las variaciones posibles
      'PORTADAS_SIGLO_XIX': '5',
      'PORTADAS SIGLO XIX': '5',
      'SIGLO_XIX': '5',
      'SIGLO XIX': '5',
      'SIGLO 19': '5',
      'XIX': '5',
      '19': '5',
      'PORTADAS_SIGLO_XX': '6',
      'PORTADAS SIGLO XX': '6',
      'SIGLO_XX': '6',
      'SIGLO XX': '6',
      'SIGLO 20': '6',
      'XX': '6',
      '20': '6',
      'PORTADAS_SIGLO_XXI': '7',
      'PORTADAS SIGLO XXI': '7',
      'SIGLO_XXI': '7',
      'SIGLO XXI': '7',
      'SIGLO 21': '7',
      'XXI': '7',
      '21': '7'
    };

    // Buscar coincidencia exacta primero
    let result = subCategoryMap[normalizedName];

    if (result) {
      return result;
    }

    // Si no hay coincidencia exacta, buscar coincidencias parciales
    // console.log('🔍 Buscando coincidencia parcial para:', normalizedName);

    // Buscar si contiene alguna palabra clave
    if (normalizedName.includes('CULTURA') || normalizedName.includes('CULTURAL')) {
      return '1';
    }
    if (normalizedName.includes('POLITIC')) {
      return '2';
    }
    if (normalizedName.includes('DEPORTE')) {
      return '3';
    }
    if (normalizedName.includes('ESPECTACULO')) {
      return '4';
    }
    if (normalizedName.includes('REGION')) {
      return '11';
    }
    if (normalizedName.includes('ECONOM')) {
      return '12';
    }
    if (normalizedName.includes('SOCIAL') || normalizedName.includes('SOCIEDAD')) {
      return '13';
    }
    if (normalizedName.includes('PRESIDENT')) {
      return '14';
    }

    // Para portadas, buscar por siglos
    if (normalizedName.includes('XIX') || normalizedName.includes('19')) {
      return '5';
    }
    if (normalizedName.includes('XX') && !normalizedName.includes('XXI') || normalizedName.includes('20')) {
      return '6';
    }
    if (normalizedName.includes('XXI') || normalizedName.includes('21')) {
      return '7';
    }

    // console.log('❌ No se encontró mapeo para:', normalizedName);
    return '';
  }
}
